<template>
    <div class="workout" :class="{'bar-visible' : (barVisible || !workoutPlaying) && workoutMounted && workoutStarted}">
        <!-- <transition name="fade-fast"> -->
            <!-- <Loader type="fullscreen" v-if="!firstDrillLoaded"></Loader> -->
        <!-- </transition> -->
        <audio src="@/assets/audio/exercise-tone.mp3" :ref="refSlugs.exerciseTone" preload="none"></audio>
        <div class="workout__container container container--full">
            <div class="workout__content" v-if="sortedSections">
                <div class="workout__logo">
                    <img alt="PUMATRAC" src="../assets/trac-logo-light.svg" />
                </div>

                <!-- ENDED -->
                <transition name="slide-fade">
                    <div class="workout__ended" v-if="workoutEnded">
                        <div class="workout__ended__title h1" v-translate>finished</div>
                        <WorkoutEnded :workout="workout" :completedWorkout="completedWorkout"></WorkoutEnded>
                    </div>
                </transition>

                <div class="workout__totalleft text text--large" v-if="!workoutEnded">
                    <translate>total_remaining</translate>: <strong>{{totalLeft ? totalLeft : formatTime(calculatedDuration)}}</strong>
                </div>

                <!-- <router-link :to="{ name: 'WorkoutOverview', params: { id: workout.id } }">
                    <div class="workout__back">
                        <Icon :name="'arrow-left'"></Icon>
                        <span v-if="!workoutEnded" v-translate>leave_workout</span>
                        <span v-else v-translate>back</span>
                    </div>
                </router-link> -->
                <div class="workout__back" @click="goBack">
                    <Icon :name="'arrow-left'"></Icon>
                    <span v-if="!workoutEnded" v-translate>leave_workout</span>
                    <span v-else v-translate>back</span>
                </div>

                <!-- INFO -->
                <div class="workout__info" v-if="!workoutEnded">
                    <div class="workout__info__inner">
                        <transition name="slide-fade">
                            <div class="workout__exercise-title" :key="activeExercise.title" v-if="workoutMounted">
                                {{activeExercise.title}}
                            </div>
                        </transition>
                        <div class="workout__info__content">
                            <transition name="slide-fade">
                                <div class="workout__exercise-duration" v-if="workoutMounted  && durationActive">
                                    {{formatDuration(activeExercise.amount)}}
                                </div>
                            </transition>
                            <transition name="slide-fade">
                                <div class="workout__getready" v-if="getReadyActive" v-translate>get_ready</div>
                            </transition>
                            <transition name="slide-fade">
                                <div class="workout__getready workout__getready--go" v-if="goActive" v-translate>go</div>
                            </transition>
                            <transition name="slide-fade">
                                <div class="workout__workout-running" v-if="videoActive">
                                    <div class="workout__timeleft">
                                        {{timerDisplay}}
                                    </div>
                                    <puma-button v-if="activeExercise.kind === 'run'" :type="'light'" @click="goToExercise(nextExercise.sectionIndex, nextExercise.exerciseIndex)" class="workout__skip-button" v-translate>skip</puma-button>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
                <!-- MEDIA -->
                <div class="workout__media" v-if="!workoutEnded">
                    <transition name="fade-fast">
                        <div class="workout__media__play" :class="{'is-unactive': workoutSoftPaused}" v-if="(!workoutStarted && firstDrillLoaded) || workoutSoftPaused" @click="startWorkout">
                            <Icon name="play-circle"></Icon>
                        </div>
                    </transition>

                    <div class="workout__media__set" @click="mediaClicked">
                        <transition name="fade">
                            <div class="workout__media__inner" v-if="activeExercise.kind === 'time'">
                                <transition name="fade">
                                    <div class="workout__media__preview" v-show="previewVideoActive">
                                        <video :src="activeExercise.previewVideoUrl" :data-slug="refSlugs.previewVideo + activeExercise.sectionIndex + activeExercise.exerciseIndex" :preload="'none'" playsinline loop v-if="workout.kind === 'stream'"></video>
                                        <video :src="activeExercise.previewVideoUrl" :data-slug="refSlugs.previewVideo + activeExercise.sectionIndex + activeExercise.exerciseIndex" :preload="'none'" muted playsinline loop v-else></video>
                                        <audio :src="activeExercise.spokenTitleUrl" preload="none" :data-slug="refSlugs.spokenTitle + activeExercise.sectionIndex + activeExercise.exerciseIndex"></audio>
                                        <audio v-if="activeExercise.spokenDuration" :src="activeExercise.spokenDuration" preload="none" :data-slug="refSlugs.spokenDuration + activeExercise.sectionIndex + activeExercise.exerciseIndex"></audio>
                                    </div>
                                </transition>
                                <transition name="fade">
                                    <div class="workout__media__main" v-show="videoActive">
                                        <div class="workout__progressbar" :data-slug="refSlugs.progressBar + activeExercise.sectionIndex + activeExercise.exerciseIndex"></div>
                                        <video :src="activeExercise.videoUrl" :data-slug="refSlugs.workoutVideo + activeExercise.sectionIndex + activeExercise.exerciseIndex" :loop="activeExercise.loopVideo" :preload="'none'" playsinline v-if="workout.kind === 'stream'"></video>
                                        <video :src="activeExercise.videoUrl" :data-slug="refSlugs.workoutVideo + activeExercise.sectionIndex + activeExercise.exerciseIndex" :loop="activeExercise.loopVideo" :preload="'none'" muted playsinline v-else></video>
                                        <audio v-for="(cue, cueIndex) in activeExercise.cues" :data-slug="refSlugs.workoutCue + activeExercise.sectionIndex + activeExercise.exerciseIndex + cueIndex" :key="cueIndex" :src="cue.audioUrl" preload="none"></audio>
                                    </div>
                                </transition>
                            </div>

                            <!-- rest and run -->
                            <div class="workout__media__inner" v-else-if="activeExercise.kind === 'media' || activeExercise.kind === 'run'">
                                <div class="workout__media__main">
                                    <div class="workout__progressbar" :data-slug="refSlugs.progressBar + activeExercise.sectionIndex + activeExercise.exerciseIndex"></div>
                                    <img :src="activeExercise.imageUrl" alt="">
                                    <audio v-if="activeExercise.spokenTitleUrl && activeExercise.kind !== 'run'" :src="activeExercise.spokenTitleUrl" preload="none" :data-slug="refSlugs.spokenTitle + activeExercise.sectionIndex + activeExercise.exerciseIndex"></audio>
                                    <audio v-if="activeExercise.spokenDuration && activeExercise.kind !== 'run'" :src="activeExercise.spokenDuration" preload="none" :data-slug="refSlugs.spokenDuration + activeExercise.sectionIndex + activeExercise.exerciseIndex"></audio>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>

                <!-- NEXT -->
                <div class="workout__next" v-if="nextExercise.exercise && !workoutEnded">
                    <div class="workout__next__title h5"><translate>next_up</translate>:</div>
                    <div class="workout__next__main" @click="goToExercise(nextExercise.sectionIndex, nextExercise.exerciseIndex)">
                        <div class="workout__next__thumbnail">
                            <img :src="nextExercise.exercise.imageUrl" alt="">
                        </div>
                        <div class="workout__next__content">
                            <div class="text text--large">{{nextExercise.exercise.title}}</div>
                            <div class="copy-label">{{formatDuration(nextExercise.exercise.amount)}}</div>
                        </div>
                    </div>
                </div>

                <!-- PAUSE -->
                <transition name="slide-fade">
                    <div class="workout__pause" v-show="!workoutPlaying && workoutMounted && !workoutEnded && workoutStarted">
                        <swiper ref="pauseSectionSlider"  :options="sliderOptions" class="workout__pause__slider">
                            <swiper-slide v-for="(exercise, exerciseIndex) in allExercises" :key="exerciseIndex" class="workout__pause__slide" :class="[{'is-active' : exercise.id === activeExercise.id}, {'first-of-section' : exercise.isFirstOfSection}]" :data-slide-index="exerciseIndex">
                                <div class="workout__pause__exercise" @click.prevent="goToExercise(exercise.sectionIndex, exercise.exerciseIndex)">
                                    <div class="workout__pause__exercise__image">
                                        <v-lazy-image :src="exercise.pauseImageUrl ? exercise.pauseImageUrl : exercise.imageUrl" alt="" />
                                        <div class="workout__pause__exercise__countdown">{{formatTime(countdown)}}</div>
                                    </div>
                                    <div class="workout__pause__exercise__title text">{{exercise.title}}</div>
                                    <div class="workout__pause__exercise__bar">
                                        <div class="workout__pause__exercise__indicator" :class="{'full' : activeSectionIndex > exercise.sectionIndex || (activeSectionIndex === exercise.sectionIndex && activeExerciseIndex > exercise.exerciseIndex)}" :data-slug="refSlugs.progressBar + exercise.sectionIndex + exercise.exerciseIndex"></div>
                                    </div>
                                    <div class="workout__pause__exercise__label copy-label copy-label--small" v-if="exercise.isFirstOfSection">{{formatSectionKind(exercise.isFirstOfSection)}}</div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>
                </transition>
            </div>

            <div class="workout__bar" v-show="!workoutEnded && workoutStarted">
                <div class="workout__bar__controls">
                    <div class="workout__bar__control" @click="playPauseWorkout">
                        <Icon :name="workoutPlaying ? 'pause' : 'play'"></Icon>
                    </div>
                    <router-link :to="{ name: 'WorkoutOverview', params: { id: workout.id } }" class="workout__bar__link">
                        <Icon :name="'stop'"></Icon>
                    </router-link>
                </div>

                <div class="workout__bar__progress">
                    <swiper ref="barSectionSlider" :options="sliderOptions" class="workout__bar__progress__slider">
                        <swiper-slide v-for="(exercise, exerciseIndex) in allExercises" :key="exerciseIndex" class="workout__bar__progress__slide" :class="{'is-active' : exercise.id === activeExercise.id}" :data-slide-index="exerciseIndex">
                            <div class="workout__bar__progress__title copy-label copy-label--small" v-if="exercise.isFirstOfSection">{{formatSectionKind(exercise.isFirstOfSection)}}</div>
                            <div class="workout__bar__progress__exercise">
                                <div class="workout__bar__progress__indicator" :class="{'full' : activeSectionIndex > exercise.sectionIndex || (activeSectionIndex === exercise.sectionIndex && activeExerciseIndex > exercise.exerciseIndex)}" :data-slug="refSlugs.progressBar + exercise.sectionIndex + exercise.exerciseIndex"></div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gsap from 'gsap'
import WorkoutEnded from "@/components/WorkoutEnded.vue";
import { mapGetters } from "vuex"

import {addTrackingObject} from "@/utils/tracking"

export default {
    components: {
        WorkoutEnded
    },
    props: {
        workout: {
            type: [Boolean, Object],
            default: false,
        }
    },
    data () {
        return {
            workoutMounted: false,
            firstDrillLoaded: false,
            workoutStarted: false,
            workoutPlaying: false,
            refSlugs: {
                exerciseTone: 'exerciseTone',
                previewVideo: 'previewVideo_',
                workoutVideo: 'workoutVideo_',
                progressBar: 'progressBar_',
                spokenTitle: 'spokenTitle_',
                workoutCue: 'workoutCue_',
                spokenDuration: 'spokenDuration_',
            },
            sortedSections: false,
            activeSectionIndex: 0,
            activeExerciseIndex: 0,
            previewVideoActive: true,
            videoActive: false,
            getReadyActive: false,
            goActive: false,
            durationActive: true,
            timerDisplay: '00:00',
            totalLeft: false,
            allExercises: [],
            animationTimeline: false,
            barVisible: false,
            calculatedDuration: 0,
            workoutEnded: false,
            countdown: 0,
            sliderOptions: {
                freeMode: 'true',
                slidesPerView: 'auto',
                mousewheel: true,
            },
            movingTimeout: 0,
            keyInteractionProgress: false,
            minPreviewVideoLength: 10,
            currentExerciseStartTime: 0,
            currentExerciseEndTime: 0,
            completedWorkout: {
                workoutId: this.workout.id,
                mode: "workout",
                startTime: 0,
                endTime: 0,
                completedExercises: []
            },
            mediaPlaying: false,
            workoutSoftPaused: false,
        }
    },
    mounted() {
        this.sortSections()
        this.animationTimeline = gsap.timeline()
        setTimeout(() => {
            this.workoutMounted = true
            this.exerciseTone.load()
            this.loadFirstDrill()
        }, 300);
    },
    beforeDestroy() {
        this.workoutMounted = false
        this.pauseWorkout(false)
        this.animationTimeline.pause(0, true).clear().kill()
        this.removeEventListeners()

        // track cancel only when workout not ended
        if(!this.workoutEnded) addTrackingObject({subSection: "home", screenName: "detailsWorkout"}, {type: "workout", value: "web_workout_cancel"});
    },
    computed: {
        ...mapGetters(['getWeight', 'getMET']),
        activeExercise() {
            return this.sortedSections[this.activeSectionIndex].exercises[this.activeExerciseIndex] ? this.sortedSections[this.activeSectionIndex].exercises[this.activeExerciseIndex] : false
        },
        nextExercise() {
            let exercise = {};
            let sectionIndex = 0;
            let exerciseIndex = 0;
            if(this.activeSectionIndex === this.sectionAmount - 1 && this.activeExerciseIndex === this.sortedSections[this.sectionAmount - 1].exercises.length - 1) {
                exercise = false;
            } else if(this.activeExerciseIndex === this.sortedSections[this.activeSectionIndex].exercises.length - 1) {
                exercise = this.sortedSections[this.activeSectionIndex + 1].exercises[0]
                sectionIndex = this.activeSectionIndex + 1
            } else {
                exercise = this.sortedSections[this.activeSectionIndex].exercises[this.activeExerciseIndex + 1]
                sectionIndex = this.activeSectionIndex
                exerciseIndex = this.activeExerciseIndex + 1
            }
            return {
                exercise: exercise,
                sectionIndex: sectionIndex,
                exerciseIndex: exerciseIndex,
            }
        },
        previousExercise() {
            let exercise = {}
            let sectionIndex = 0
            let exerciseIndex = 0;

            if(this.activeSectionIndex === 0 && this.activeExerciseIndex === 0) {
                exercise = false
            } else if(this.activeExerciseIndex === 0 && this.activeSectionIndex !== 0) {
                exercise = this.sortedSections[this.activeSectionIndex - 1].exercises[this.sortedSections[this.activeSectionIndex - 1].exercises.length - 1]
                sectionIndex = this.activeSectionIndex - 1
                exerciseIndex = this.sortedSections[this.activeSectionIndex - 1].exercises.length - 1
            } else {
                exercise = this.sortedSections[this.activeSectionIndex].exercises[this.activeExerciseIndex - 1]
                sectionIndex = this.activeSectionIndex
                exerciseIndex = this.activeExerciseIndex - 1
            }

            return {
                exercise: exercise,
                sectionIndex: sectionIndex,
                exerciseIndex: exerciseIndex,
            }
        },
        sectionAmount () {
            return this.sortedSections.length
        },
        exerciseTone() {
            return this.$refs[this.refSlugs.exerciseTone]
        },
        activePreviewVideo() {
            return this.$el.querySelector(`[data-slug="${this.refSlugs.previewVideo}${this.activeSectionIndex}${this.activeExerciseIndex}"]`)
        },
        activeWorkoutVideo() {
            return this.$el.querySelector(`[data-slug="${this.refSlugs.workoutVideo}${this.activeSectionIndex}${this.activeExerciseIndex}"]`)
        },
        activeSpokenTitle() {
            return this.activeExercise.spokenTitleUrl !== null ? this.$el.querySelector(`[data-slug="${this.refSlugs.spokenTitle}${this.activeSectionIndex}${this.activeExerciseIndex}"]`) : false;
        },
        activeSpokenDuration() {
            const spokenDurationEl = this.$el.querySelector(`[data-slug="${this.refSlugs.spokenDuration}${this.activeSectionIndex}${this.activeExerciseIndex}"]`)
            return spokenDurationEl ? spokenDurationEl : false;
        },
        activeCue() {
            const activeCueEl = this.$el.querySelector(`[data-slug="${this.refSlugs.workoutCue}${this.activeSectionIndex}${this.activeExerciseIndex}${this.activeExercise.cueToPlay}"]`)
            return activeCueEl ? activeCueEl : false;
        },
        totalPassed () {
            let passedTime = 0;
            this.sortedSections.forEach((section, sectionIndex) => {
                section.exercises.forEach((exercise, exerciseIndex) => {
                    if(this.activeSectionIndex > sectionIndex || (this.activeSectionIndex === sectionIndex && this.activeExerciseIndex > exerciseIndex)) {
                        passedTime += exercise.amount + (exercise.previewVideoLength !== null ? (exercise.previewVideoLength > this.minPreviewVideoLength ? Math.floor(exercise.previewVideoLength) : this.minPreviewVideoLength) : 0)
                    }
                }) 
            }) 
            return passedTime
        },
    },
    methods: {
        addEventListeners() {
            this.$el.addEventListener('mousemove', this.mouseMoveEvent)

            document.addEventListener('keydown', this.keyDownEvent)
        },
        mouseMoveEvent() {
            const isOverBar = event.target.closest('.workout__bar') !== null
            this.barVisible = true
            if(this.movingTimeout !== undefined) {
                clearTimeout(this.movingTimeout)
            }
            this.movingTimeout = setTimeout(() => {
                this.barVisible = isOverBar
            }, 3000);
        },
        keyDownEvent() {
            // space press to toggle play/pause
            if(event.keyCode === 32) {
                if(!this.workoutStarted) {
                    this.startWorkout()
                } else {
                    this.playPauseWorkout()
                }
            }
            // arrow left
            else if(event.keyCode === 37) {
                if(this.previousExercise.exercise) this.goToExercise(this.previousExercise.sectionIndex, this.previousExercise.exerciseIndex)
            }
            // arrow right
            else if(event.keyCode === 39) {
                if(this.nextExercise.exercise) this.goToExercise(this.nextExercise.sectionIndex, this.nextExercise.exerciseIndex)
            }
        },
        removeEventListeners() {
            this.$el.removeEventListener('mousemove', this.mouseMoveEvent)
            document.removeEventListener('keydown', this.keyDownEvent)
        },
        mediaClicked() {
            if(this.mediaPlaying) {
                this.workoutSoftPaused = true;
                this.pauseWorkout(false)
            } else {
                this.playWorkout();
            }
        },
        sortSections() {
            let exerciseCounter = 0;
            this.sortedSections = this.workout.sections.sort((a, b) => (a.order > b.order) ? 1 : -1);
            this.sortedSections.forEach((section, sectionIndex) => {
                section.exercises = section.exercises.sort((a, b) => (a.order > b.order) ? 1 : -1);
                section.exercises.forEach((exercise, exerciseIndex) => {
                    exercise.cues.sort((a, b) => (a.order > b.order) ? 1 : -1);
                    this.calculatedDuration += exercise.amount
                    this.calculatedDuration += (exercise.previewVideoLength !== null ? (exercise.previewVideoLength > this.minPreviewVideoLength ? Math.floor(exercise.previewVideoLength) : this.minPreviewVideoLength) : 0)
                    this.$set(exercise, 'isFirstOfSection', exerciseIndex === 0 ? section.kind : false)
                    this.$set(exercise, 'sectionExerciseIndex', `${sectionIndex}${exerciseIndex}`)
                    this.$set(exercise, 'sectionIndex', sectionIndex)
                    this.$set(exercise, 'exerciseIndex', exerciseIndex)
                    this.$set(exercise, 'totalExerciseIndex', exerciseCounter)

                    let sameExercises = this.allExercises.filter((ex) => { return ex.templateId === exercise.templateId})
                    let cuesAmount = exercise.cues.length;
                    if(sameExercises.length > 0 && sameExercises.length >= cuesAmount) {
                        if((sameExercises.length - cuesAmount) >= cuesAmount) {
                            let multiplier = Math.floor(sameExercises.length / cuesAmount)
                            this.$set(exercise, 'cueToPlay', sameExercises.length - cuesAmount * multiplier)
                        } else {
                            this.$set(exercise, 'cueToPlay', sameExercises.length - cuesAmount)
                        }
                    } else {
                        this.$set(exercise, 'cueToPlay', sameExercises.length)
                    }

                    this.allExercises.push(exercise)
                    exerciseCounter++
                })
            })
        },
        formatSectionKind(kind) {
            return kind.split('_').join(' ')
        },
        formatTime(duration) {
            if(duration === 0) {
                return '00:00'
            }
            let minutes = Math.floor(duration / 60);
            let seconds = Math.floor(duration % 60);
            return `${this.padNumber(minutes)}:${this.padNumber(seconds)}`;
        },
        formatDuration(duration) {
            if(duration < 60) {
                return duration + ' ' + this.$gettext('sec_abbr')
            } else {
                const minutes = Math.floor(duration / 60);
                const seconds = Math.floor(duration % 60);
                return `${minutes > 0 ? `${minutes} ${this.$gettext('min_abbr')}` : ''} ${seconds > 0 ? ` ${seconds} ${this.$gettext('sec_abbr')}` : ''}`
            }
        },
        padNumber (number) {
            if (number < 10) {
                return `0${number}`;
            } else {
                return number;
            }
        },
        loadFirstDrill() {
            this.activePreviewVideo.load()

            this.activeWorkoutVideo.load()

            if(this.activeSpokenTitle) {
                this.activeSpokenTitle.load()
            }

            const videoLoaded = setInterval(() => {
                if (    (this.activePreviewVideo.readyState >= 3 && this.activeWorkoutVideo.readyState >= 3 && !this.activeSpokenTitle) || 
                            (this.activePreviewVideo.readyState >= 3 && this.activeWorkoutVideo.readyState >= 3 && this.activeSpokenTitle && this.activeSpokenTitle.readyState >= 3)
                    ) {
                    this.firstDrillLoaded = true;
                    this.$emit('firstDrillLoaded');
                    this.addEventListeners()
                    clearInterval(videoLoaded)
                }
            }, 100)
        },
        startWorkout() {
            this.workoutStarted = true
            this.completedWorkout.startTime = new Date().toISOString();
            this.playExercise()

            addTrackingObject({subSection: "home", screenName: "detailsWorkout"}, {type: "workout", value: "web_workout_start"});
        },
        playExercise() {
            this.workoutPlaying = true
            this.previewVideoActive = true
            this.goActive = false
            this.getReadyActive = false
            this.animationTimeline.pause(0, true).clear()
            this.countdown = 0
            this.currentExerciseStartTime = new Date().toISOString()
            this.workoutSoftPaused = false;
            
            // drill
            if(this.activeExercise.kind === 'time') {
                this.videoActive = false
                this.durationActive = true

                this.playDrill()
            // transition (rest)
            } else if(this.activeExercise.kind === 'media' || this.activeExercise.kind === 'run') {
                this.videoActive = true
                this.durationActive = false
                this.playMedia()
            }

            // adjust sliders
            this.positionSlider(this.$refs.barSectionSlider)
        },
        playDrill() {
            // preview video
            const previewVideoDuration = Math.floor(this.activeExercise.previewVideoLength) > this.minPreviewVideoLength ? Math.floor(this.activeExercise.previewVideoLength) : this.minPreviewVideoLength
            this.activePreviewVideo.pause()
            this.activePreviewVideo.currentTime = 0
            this.activePreviewVideo.load()

            // workout video
            const workoutDuration = parseInt(this.activeExercise.amount)
            this.activeWorkoutVideo.pause()
            this.activeWorkoutVideo.currentTime = 0
            this.activeWorkoutVideo.load()

            // spoken title audio
            if(this.activeSpokenTitle) {
                this.activeSpokenTitle.pause()
                this.activeSpokenTitle.currentTime = 0
                this.activeSpokenTitle.load()
            }

            // spoken duration
            if(this.activeSpokenDuration) {
                this.activeSpokenDuration.pause()
                this.activeSpokenDuration.currentTime = 0
                this.activeSpokenDuration.load()
            }

            // cues audio
            if(this.activeCue) {
                this.activeCue.pause()
                this.activeCue.currentTime = 0
                this.activeCue.load()
            }

            // exercise tone
            this.exerciseTone.pause()
            this.exerciseTone.currentTime = 0
            const exerciseToneLength = !isNaN(this.exerciseTone.duration) ? this.exerciseTone.duration : 1

            // progress bar
            const activeProgressBars = this.$el.querySelectorAll(`[data-slug="${this.refSlugs.progressBar}${this.activeSectionIndex}${this.activeExerciseIndex}"]`)

            // countdown
            let countdown = parseInt(this.activeExercise.amount)
            this.timerDisplay = this.formatTime(countdown)

            this.mediaPlaying = true;


            const videoLoaded = setInterval(() => {                
                if (    (this.activePreviewVideo.readyState >= 3 && this.activeWorkoutVideo.readyState >= 3 && !this.activeSpokenTitle) || 
                        (this.activePreviewVideo.readyState >= 3 && this.activeWorkoutVideo.readyState >= 3 && this.activeSpokenTitle && this.activeSpokenTitle.readyState >= 3)
                ) {
                    
                    this.animationTimeline
                        // start preview video and audio
                        .add(() => {
                            this.activePreviewVideo.play()
                            if(this.activeSpokenTitle.readyState >= 3) this.activeSpokenTitle.play()
                        }, 0)
                        // show / hide get ready
                        .add(() => {
                            this.durationActive = false,
                            this.getReadyActive = true
                            if(this.activeSpokenDuration.readyState >= 3) this.activeSpokenDuration.play()
                        }, 2.8)
                        .add(() => {
                            this.getReadyActive = false
                        }, previewVideoDuration - 2.3)
                        // show / hide go
                        .add(() => {
                            this.goActive = true
                            this.exerciseTone.play()
                        }, previewVideoDuration - 1.8)
                        .add(() => {
                            this.goActive = false
                        }, previewVideoDuration - 0.1)
                        // start actual video
                        .add(() => {
                            this.previewVideoActive = false
                            this.videoActive = true

                            this.activeWorkoutVideo.play()
                            if(this.activeCue.readyState >= 3) this.activeCue.play()
                        }, previewVideoDuration)
                        // add countdown
                        .eventCallback('onUpdate', () => {
                            const timelineTime = Math.floor(this.animationTimeline.time())

                            let totalDuration = previewVideoDuration + workoutDuration
                            let countdown = totalDuration - timelineTime
                            if(countdown < 0) countdown = 0
                            this.timerDisplay = this.formatTime(countdown)
                            this.countdown = timelineTime <= previewVideoDuration ? 0 : (timelineTime - previewVideoDuration)

                            // total time left
                            let totalLeft = this.calculatedDuration - this.totalPassed - timelineTime
                            if(totalLeft <= 0) totalLeft = 0
                            this.totalLeft = this.formatTime(totalLeft)
                        })
                        // exercise tone before switching
                        .add(() => {
                            this.exerciseTone.play()
                        }, previewVideoDuration + workoutDuration - exerciseToneLength)
                        // switch exercise
                        .add(() => {
                            this.goToNextExercise()
                        }, previewVideoDuration + workoutDuration)

                    // progress bars
                    activeProgressBars.forEach(bar => {
                        this.animationTimeline.add(gsap.fromTo(bar, {width: 0}, {width: '100%', ease: 'linear', duration: workoutDuration}), previewVideoDuration)
                    })

                    this.animationTimeline.play()

                    clearInterval(videoLoaded)
                }
            }, 100);
        },
        playMedia() {
            const workoutDuration = parseInt(this.activeExercise.amount)
            const exerciseToneLength = !isNaN(this.exerciseTone.duration) ? this.exerciseTone.duration : 1

            this.mediaPlaying = true;

            // progress bar
            const activeProgressBars = this.$el.querySelectorAll(`[data-slug="${this.refSlugs.progressBar}${this.activeSectionIndex}${this.activeExerciseIndex}"]`)

            // countdown
            let countdown = parseInt(this.activeExercise.amount)
            this.timerDisplay = this.formatTime(countdown)

            // spoken title audio
            let spokenTitleDuration = 0
            if(this.activeSpokenTitle) {
                this.activeSpokenTitle.pause()
                this.activeSpokenTitle.currentTime = 0
                this.activeSpokenTitle.load()
                spokenTitleDuration = 2
                setTimeout(() => {
                    spokenTitleDuration = this.activeSpokenTitle.duration
                }, 100);
            }

            // spoken duration
            if(this.activeSpokenDuration) {
                this.activeSpokenDuration.pause()
                this.activeSpokenDuration.currentTime = 0
                this.activeSpokenDuration.load()
            }

            const audioLoaded = setInterval(() => {
                if((this.activeSpokenTitle && this.activeSpokenTitle.readyState >= 3) || !this.activeSpokenTitle) {
                    this.animationTimeline
                        // add countdown
                        .eventCallback('onUpdate', () => {
                            const timelineTime = Math.floor(this.animationTimeline.time())

                            let totalDuration = workoutDuration
                            let countdown = totalDuration - timelineTime
                            if(countdown < 0) countdown = 0
                            this.timerDisplay = this.formatTime(countdown)
                            this.countdown = timelineTime

                            // total time left
                            let totalLeft = this.calculatedDuration - this.totalPassed - timelineTime
                            if(totalLeft <= 0) totalLeft = 0
                            this.totalLeft = this.formatTime(totalLeft)
                        })
                        .add(() => {
                            this.exerciseTone.play()
                        }, workoutDuration - exerciseToneLength)
                        // switch exercise
                        .add(() => {
                            this.goToNextExercise()
                        }, workoutDuration)

                    // spoken title
                    if(this.activeSpokenTitle) {
                        this.animationTimeline
                            .add(() => {
                            this.activeSpokenTitle.play()
                        }, 0)
                    }

                    // spoken duration
                    if(this.activeSpokenDuration) {
                        this.animationTimeline
                            .add(() => {
                                if(this.activeSpokenDuration.readyState >= 3) this.activeSpokenDuration.play()
                            }, spokenTitleDuration + 1)
                    }

                    // progress bars
                    activeProgressBars.forEach(bar => {
                        this.animationTimeline.add(gsap.fromTo(bar, {width: 0}, {width: '100%', ease: 'linear', duration: workoutDuration}), 0)
                    })

                    this.animationTimeline.play()

                    clearInterval(audioLoaded)
                }
            }, 100)
        },
        // only use for programatically switching exercises
        goToNextExercise() {
            // reset the workout
            this.pauseWorkout(false)
            this.currentExerciseEndTime = new Date().toISOString()

            // push to completed exercises
            this.completedWorkout.completedExercises.push({
                exerciseId: this.activeExercise.id,
                duration: this.activeExercise.amount,
                startTime: this.currentExerciseStartTime,
                endTime: this.currentExerciseEndTime,
                calories: Math.round(this.getMET(this.sortedSections[this.activeSectionIndex], this.workout.difficulty) * this.getWeight * (this.activeExercise.amount / 3600)),
                score: Math.ceil((this.getWeight * (this.activeExercise.amount  / 3600)) / 100),
                totalExerciseIndex: this.activeExercise.totalExerciseIndex,
            })

            if(this.activeSectionIndex === this.sectionAmount - 1 && this.activeExerciseIndex === this.sortedSections[this.sectionAmount - 1].exercises.length - 1) {
                this.endWorkout()
            } else if(this.activeExerciseIndex === this.sortedSections[this.activeSectionIndex].exercises.length - 1) {
                this.activeSectionIndex++
                this.activeExerciseIndex = 0

                setTimeout(() => {
                    this.playExercise()
                }, 100);
            } else {
                this.activeExerciseIndex++
                setTimeout(() => {
                    this.playExercise()
                }, 100);
            }
        },
        // use for manually switching exercises
        goToExercise(sectionIndex, exerciseIndex) {
            if(!this.workoutStarted) return

            // reset the workout
            this.pauseWorkout(false)

            const oldTotalExerciseIndex = this.activeExercise.totalExerciseIndex

            this.activeSectionIndex = sectionIndex;
            this.activeExerciseIndex = exerciseIndex;
            setTimeout(() => {
                let newTotalExerciseIndex = this.activeExercise.totalExerciseIndex
                this.updateCompletedExercises(oldTotalExerciseIndex, newTotalExerciseIndex)
                this.playExercise()
            }, 100);
        },
        updateCompletedExercises(oldIndex, newIndex) {
            // when going back, delete everything up to the newindex
            if(newIndex <= oldIndex) {
                const newExercises = this.completedWorkout.completedExercises.filter(exercise => {
                    return exercise.totalExerciseIndex < newIndex
                })
                this.completedWorkout.completedExercises = newExercises.slice()
            }
        },
        playPauseWorkout() {
            if(this.workoutPlaying) {
                this.pauseWorkout()
            } else {
                this.playWorkout()
            }
        },
        pauseWorkout(setPlaying = true) {
            this.animationTimeline.pause()
            if(this.activeSpokenTitle) this.activeSpokenTitle.pause()
            if(this.activeSpokenDuration) this.activeSpokenDuration.pause()
            if(this.activeExercise.kind === 'time') {
                this.activePreviewVideo.pause()
                this.activeWorkoutVideo.pause()
                if(this.activeCue) this.activeCue.pause()
            }
            setTimeout(() => {
                    this.positionSlider(this.$refs.pauseSectionSlider, 0)
            }, 10);
            this.mediaPlaying = false;
            if(setPlaying) this.workoutPlaying = false
        },
        playWorkout() {
            this.animationTimeline.play()

            if(this.activeExercise.kind === 'time') {
                if(!this.activePreviewVideo.ended && this.previewVideoActive)this.activePreviewVideo.play()
                if(!this.activeWorkoutVideo.ended && this.videoActive)this.activeWorkoutVideo.play()
                if(!this.activeSpokenTitle.ended && this.previewVideoActive) this.activeSpokenTitle.play()
                if(!this.activeCue.ended && this.videoActive && this.activeCue) this.activeCue.play()
                if(this.activeSpokenDuration && !this.activeSpokenDuration.ended && this.previewVideoActive && this.activeSpokenTitle.ended && this.activeSpokenDuration.readyState >= 3) this.activeSpokenDuration.play()
            }
            this.mediaPlaying = true;
            this.workoutSoftPaused = false;
            this.workoutPlaying = true
        },
        endWorkout() {
            this.activeExercise = false
            this.workoutEnded = true
            this.pauseWorkout(false)
            this.animationTimeline.pause(0, true).clear()
            this.completedWorkout.endTime = new Date().toISOString();
            
            addTrackingObject({subSection: "home", screenName: "detailsWorkout"}, {type: "workout", value: "web_workout_finish"});
        },
        positionSlider(slider, speed = 600) {
            if(slider) {
                const activeExerciseIndex = slider.$el.querySelector('.is-active').dataset.slideIndex
                slider.$swiper.slideTo(activeExerciseIndex, speed)
            }
        },
        goBack() {
            // window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
        }
    }
}
</script>

<style scoped lang="scss">
@import "~sass-mq";

.workout {
    $block: &;

    background: black;
    color: white;
    height: $fullheight;

    &__container {
        @include mq($until: desktop, $and: '(orientation: portrait)') {
            display: flex;
            justify-content: center;
        }
    }

    &__content {
        position: relative;
        display: flex;
        background: black;
        height: $fullheight;
    }

    &__logo {
        position: absolute;
        top: 40px;
        right: 40px;
        z-index: 5;

        @include mq($until: notebook) {
            top: 25px;
            right: 0;
        }

        @include mq($until: desktop) {
            top: $page-padding-small;
            right: $page-padding-small;

            img {
                height: 25px;
            }
        }
    }

    &__totalleft {
        position: absolute;
        left: 0;
        bottom: 40px;
        transition: margin 300ms $ease-out-quad;
        margin-bottom: 0;
        z-index: 5;

        @include mq($until: desktop, $and: '(orientation: portrait)') {
            left: $page-padding-small;
            margin-bottom: 0 !important;
            bottom: 28px;
        }

        .bar-visible & {
            margin-bottom: $workout-bar-height
        }
    }

    &__info {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: (5 * 100% / 12);

        @include mq($until: laptop) {
            @media screen and (min-height: 1000px) {
                width: (4 * 100% / 12);
            }
        }

        @include mq($until: notebook) {
            width: (4 * 100% / 12);
        }

        @include mq($until: desktop, $and: '(orientation: portrait)') {
            position: absolute;
            top: 60px;
            left: 0;
            width: 100%;
            z-index: 4;
            align-items: stretch;
        }

        &__inner {
            padding-left: 10px;
            padding-right: 20px;

            @include mq($until: desktop, $and: '(orientation: portrait)') {
                padding: 0 $page-padding-small;
            }
        }

        &__content {
            position: relative;
            width: 400px;
            height: 250px;

            @include mq($until: notebook) {
                width: 320px;
                height: 150px;
            }

            @include mq($until: desktop) {
                width: 250px;
            }

            @include mq($until: desktop, $and: '(orientation: portrait)') {
                width: 100%;
                height: auto;
            }

            & > * {
                position: absolute;
                top: 0;
                left: 0;
            }
        }
    }

    &__back {
        position: absolute;
        top: 40px;
        left: 0;
        color: white;
        text-transform: uppercase;
        font-weight: $font-weight-bold;
        display: flex;
        align-items: center;
        z-index: 10;
        cursor: pointer;

        @include mq($until: notebook) {
            top: 25px;
        }

        @include mq($until: desktop) {
            top: $page-padding-small;
            left: $page-padding-small;
            font-size: $puma-size-font-xs;
        }

        .icon {
            margin-right: 16px;

            @include mq($until: desktop) {
                width: $page-padding-small;
                height: $page-padding-small;
            }
        }
    }

    &__exercise-title {
        font-size: $puma-size-font-4xl;
        font-weight: $font-weight-bold;
        line-height: 1.25;
        text-transform: uppercase;
        margin-bottom: 30px;

        @include mq($until: notebook) {
            font-size: $puma-size-font-2xl;
            margin-bottom: 20px;
        }

        @include mq($until: desktop) {
            font-size: $puma-size-font-lg;
            margin-bottom: 0;
        }
    }

    &__exercise-duration {
        text-transform: uppercase;
        font-weight: 300;
        font-size: $puma-size-font-xl;
        margin-top: -20px;

        @include mq($until: desktop) {
            margin-top: 0;
            font-size: $puma-size-font-md;
        }
    }

    &__timeleft {
        font-size: $puma-size-font-11xl;
        font-weight: $font-weight-bold;
        margin-left: -10px;
        line-height: 1;

        @include mq($until: laptop) {
            font-size: $puma-size-font-10xl;
        }

        @include mq($until: notebook) {
            font-size: $puma-size-font-9xl;
        }

        @include mq($until: desktop) {
            font-size: $puma-size-font-7xl;
            margin-left: 0;
        }

        @include mq($until: tablet-landscape) {
            font-size: $puma-size-font-5xl;
        }
    }

    &__getready {
        font-size: $puma-size-font-8xl;
        font-weight: $font-weight-bold;
        text-transform: uppercase;
        line-height: 1;

        @include mq($until: notebook) {
            font-size: $puma-size-font-6xl;
        }

        @include mq($until: desktop) {
            font-size: $puma-size-font-5xl;
        }

        &--go {
            font-size: $puma-size-font-9xl;

            @include mq($until: desktop) {
                font-size: $puma-size-font-8xl;
            }
        }
    }

    &__media {
        position: relative;
        flex-shrink: 0;
        line-height: 0;

        &__play {
            @include fillout;
            cursor: pointer;
            z-index: 3;

            display: flex;
            justify-content: center;
            align-items: center;

            &.is-unactive {
                pointer-events: none;
            }

            .icon {
                color: white;
                width: 80px;
                height: 80px;
            }
        }

        &__inner {
            position: relative;
            height: $fullheight;
            width: (444 * 100vh / 800);

            @include mq($until: desktop, $and: '(orientation: portrait)') {
                max-width: 100vw;
            }

            & > * {
                @include fillout;
                width: 100%;
                height: 100%;
            }

            video,
            img {
                @include object-fit;
            }
        }

        &__preview {
            &:before {
                content: '';
                display: block;
                background-color: rgba(0, 0, 0, 0.3);
                @include fillout;
                z-index: 2;
            }
        }

        &__main {
            position: relative;
        }
    }

    &__progressbar {
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 0;
        opacity: 0.6;
        background-color: rgba(0, 0, 0, 0.3);
        z-index: 3;
    }

    &__next {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding: 40px 0 30px 40px;
        transition: margin 300ms $ease-out-quad;
        margin-bottom: 0;

        @include mq($until: desktop) {
            padding: 40px 0 30px 25px;
        }

        @include mq($until: tablet-landscape) {
            display: none;
        }

        @include mq($until: desktop, $and: '(orientation: portrait)') {
            display: none;
        }

        .bar-visible & {
            margin-bottom: $workout-bar-height;
        }

        &__title {
            margin-bottom: 20px;

            @include mq($until: desktop) {
                margin-bottom: 10px;
            }
        }

        &__main {
            display: flex;
            align-items: center;
            cursor: pointer;

            @include mq($until: notebook) {
                flex-wrap: wrap;
            }
        }

        &__thumbnail {
            position: relative;
            width: 74px;
            height: 74px;
            margin-right: 20px;
            flex-shrink: 0;
            margin-bottom: 10px;

            img {
                @include object-fit;
            }

            @include mq($until: notebook) {
                width: 60px;
                height: 60px;
            }
        }

        &__content {
            margin-bottom: 10px;
        }
    }

    &__bar {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        height: $workout-bar-height;
        background: white;
        color: black;
        z-index: 100;
        display: flex;
        align-items: center;
        transition: transform 300ms $ease-out-quad;
        transform: translateY(100%);

        .bar-visible & {
            transform: none;
        }

        @include mq($until: desktop, $and: '(orientation: portrait)') {
            transform: translateX(-50%) !important;
            background: transparent;
            justify-content: flex-end;
            height: auto;
            width: (444 * 100vh / 800);
            max-width: 100vw;
            left: 50%;
            bottom: $page-padding-small;
            padding-right: $page-padding-small;
        }

        &__controls {
            padding: 0 24px 0 20px;
            display: flex;
            align-items: center;
            flex-shrink: 0;
            width: 120px;
            line-height: 1;

            @include mq($until: desktop, $and: '(orientation: portrait)') {
                width: auto;
                padding: 0;
            }
        }

        &__control {
            margin-right: 12px;

            @include mq($until: desktop, $and: '(orientation: portrait)') {
                margin: 0;
                width: 40px;
                height: 40px;
                background: white;
                border-radius: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                .icon {
                    width: 26px;
                    height: 26px;
                }
            }
        }

        &__link {
            @include mq($until: desktop, $and: '(orientation: portrait)') {
                display: none;
            }
        }

        &__progress {
            height: 100%;
            width: calc(100% - 120px);
            flex-grow: 1;

            @include mq($until: desktop, $and: '(orientation: portrait)') {
                display: none;
            }

            &__slider {
                height: 100%;
            }

            &__slide {
                display: flex;
                align-items: center;
                margin-right: 4px;
                width: auto !important;

                &:not(:first-child) {
                    #{$block}__bar__progress__title {
                        margin-left: 40px;
                    }
                }
            }

            &__title {
                margin-right: 20px;
                flex-shrink: 0;
            }

            &__exercise {
                position: relative;
                width: 348px;
                height: 4px;
                background-color: rgba(black, 0.1);

                @include mq($until: notebook) {
                    width: 280px;
                }

                @include mq($until: tablet-landscape) {
                    width: 120px;
                }
            }

            &__indicator {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 0;
                background: black;

                &.full {
                    width: 100% !important;
                }
            }
        }
    }

    &__pause {
        @include fillout;
        left: -1px;
        right: -1px;
        background: black;
        padding: 120px 0 170px;
        overflow: visible;
        z-index: 4;
        display: flex;
        align-items: center;

        @include mq($until: desktop, $and: '(orientation: portrait)') {
            padding: 70px $page-padding-small 100px;
        }

        &__slider {
            overflow: visible;
            width: 100%;
        }

        &__slide {
            margin-right: 4px;
            width: auto !important;

            &.first-of-section {
                &:not(:first-child) {
                    margin-left: 20px;
                }

                #{$block}__pause__exercise__bar {
                    &:before {
                        content: '';
                        display: block;
                        position: absolute;
                        top: 0;
                        left: 0;
                        background: white;
                        height: 40px;
                        width: 1px;
                    }
                }
            }

            &.is-active {
                #{$block}__pause__exercise {
                    &__image {
                        &:before {
                            opacity: 1;
                        }
                    }
                    &__countdown {
                        display: block;
                    }
                }
            }
        }

        &__exercise {
            position: relative;
            display: flex;
            flex-direction: column;
            margin-bottom: 40px;
            width: 216px + 8px;
            cursor: pointer;

            @include mq($until: desktop, $and: '(orientation: portrait)') {
                width: 150px + 8px;
            }

            &:not(:last-child) {
                margin-right: 4px;
            }
            
            &__image {
                position: relative;
                width: calc(100% - 8px);
                margin-right: 8px;

                &:before {
                    content: '';
                    @include fillout;
                    background: rgba(black, 0.5);
                    opacity: 0;
                    transition: opacity 300ms $ease-out-quad;
                    z-index: 1;
                }
                
                &:after {
                    content: '';
                    display: block;
                    padding-bottom: (389 * 100% / 216);
                }

                img {
                    @include object-fit;
                }
            }

            &__countdown {
                position: absolute; 
                z-index: 2;
                font-size: $puma-size-font-7xl;
                font-weight: $font-weight-bold;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                display: none;

                @include mq($until: desktop, $and: '(orientation: portrait)') {
                    font-size: $puma-size-font-5xl;
                }
            }

            &__title {
                text-align: center;
                margin-top: 12px;
                padding: 0 10px;
                min-height: 48px;
                margin-bottom: 24px;

                @include mq($until: desktop, $and: '(orientation: portrait)') {
                    margin-bottom: 12px;
                }
            }

            &__bar {
                position: relative;
                width: 100%;
                height: 12px;
                background: rgba(white, 0.4);
                margin-top: auto;

                @include mq($until: desktop, $and: '(orientation: portrait)') {
                    height: 10px;
                }
            }

            &__indicator {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                width: 0;
                background: white;

                &.full {
                    width: 100% !important;
                }
            }

            &__label {
                position: absolute;
                top: 100%;
                margin-top: 4px;
                left: 9px;
            }
        }
    }

    &__skip-button {
        margin-top: 30px
    }

    &__ended {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 100px 0 80px;

        @include mq($until: tablet) {
            justify-content: flex-start;
            overflow: auto;
        }

        &__title {
            margin-bottom: 40px;
        }
    }
}
</style>